import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import LinkIcon from "../../images/link.svg"

const Navigation = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0rem 0 0;
  a {
    &.active {
      color: ${(props) => props.theme.colors.primary};
    }
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
    // font-size: 14px;
    font-family: ${(props) => props.theme.fontCondensed};
    line-height: 1;
    color: ${(props) => props.theme.colors.secondary};
    text-decoration: none;
    // margin: 0.25rem;
    border-bottom: 1px solid transparent;
    transition: 0.2s;
    
    //&:hover,
    &[aria-current="page"],
    &.active {
      //border-bottom: 2px solid ${(props) => props.theme.colors.secondary};
    }
    ul {
      padding: 0;
      width: 100px;
      @media screen and (max-width: ${(props) => props.theme.breakpoints.desktop}) {
          width: 70px;
      }
      border-bottom: 2px solid ${(props) => props.theme.colors.primary};
      padding-bottom: 2.5rem;
      &:hover {
        padding-bottom: 2.3rem;
        transition: all 0.1s ease-in-out;
      }
      transition: all 0.2s ease-in-out;
      li {
        margin: 0;
        display: block;
        padding-bottom: 0.3rem;
        :first-child {
          font-size: 0.6rem;
        }
        :last-child {
          font-size: 1rem;
          font-family: ${(props) => props.theme.fontBold};
          @media screen and (max-width: ${(props) => props.theme.breakpoints.desktop}) {
              font-size: 0.8rem;
          }
        }
      }
    }
    
  }
  a.grow {
    position: relative;
  }
  a.grow:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -4px;
    left: 0;
    background-color: ${(props) => props.theme.colors.secondary};
    visibility: hidden;
    width: 0;
    transition: all 0.2s ease-in-out;
  }
  a.grow:hover:before {
    visibility: visible;
    width: 100%
  }
  a.grow.active:before {
    visibility: visible;
    width: 100%
  }
  li {
    display: inline-block;
    margin: 0 1.5rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.desktop}) {
        margin: 0 1rem;
    }
    &:last-child {
      margin-right: 0;
    }
  }
`;

const Menu = () => {
  return (
    <nav>
      <Navigation>
        <li>
          <Link to="/about" className="" activeClassName="active">
            <ul>
              <li className="hide">107 YEAR HISTORY</li>
              <li>About</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/visiting" className="" activeClassName="active"> 
            <ul>
              <li className="hide">MAPS &amp; TRAVEL</li>
              <li>Visiting</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/spaces" className="" activeClassName="active">
            <ul>
              <li className="hide">APPLY / HIRE</li>
              <li>Spaces</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/trader-directory" className="" activeClassName="active" partiallyActive={true}>
            <ul>
              <li className="hide">DIRECTORY</li>
              <li>Traders</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/news" className="" activeClassName="active" partiallyActive={true}>
            <ul>
              <li className="hide">NEWS &amp; EVENTS</li>
              <li>What’s On</li>
            </ul>
          </Link>
        </li>
      </Navigation>
    </nav>
  )
}

export default Menu
